import React from 'react';
import { API_URL } from "../App";

const Settings: React.FC = () => {
    return (
        <section className="section">
            <h1>Settings</h1>
            <p style={{ opacity: 0.8 }}>
                The settings will appear here once created.
            </p>
        </section>
    );
};

export default Settings;
